'use strict';

require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require("../../company/publications/companyOrder/CompanyPublicationCompanyOrderService.js");

var LIMIT = 21;
function CompanyGuestCompanyOrderDetailCtrl(
  $scope,
  publication,
  order,
  files,
  translations,
  $translate,
  $stateParams,
  $state,
  orderStatuses,
  CompanyPublicationService,
  CompanyProductsService,
  CompanyService,
  CompanyCustomersService,
  CompanyPublicationCompanyOrderService,
  $sce,
  config,
  $filter,
  activityService,
  $modal,
  $http,
  projects,
  growl
) {
  $scope.publication         = publication;
  $scope.translations        = translations;
  $scope.activityService     = activityService;
  $scope.order               = order;
  $scope.files               = files.slice(0, LIMIT);
  $scope.currentPage         = $stateParams.page|0;
  $scope.hasMore             = files.length > LIMIT;
  $scope.orderStatuses       = orderStatuses;
  $scope.projects            = projects;
  $scope.orderStatusesSorted = ($filter('orderBy')($scope.orderStatuses, 'stepNr')).filter(function(v){
    return v.stepNr > 0;
  });
  $scope.searchFileStr       = $stateParams.searchFile || "";
  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/company-order/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

  $scope.paymentTypes = [
    {
      'name': $translate.instant('order.payment.cash-on-delivery'),
      'value': 'CASH_ON_DELIVERY'
    }, {
      'name': $translate.instant('order.payment.10-days'),
      'value': '10_DAYS'
    }, {
      'name': $translate.instant('order.payment.20-days'),
      'value': '20_DAYS'
    }, {
      'name': $translate.instant('order.payment.30-days'),
      'value': '30_DAYS'
    }
  ];

  $scope.nonProductsAdded = [];
  var nonProdcutAddedPromise;
  var totalOrder = function(includeTax) {
    var total = 0;
    if ($scope.order) {
      angular.forEach($scope.order.items, function(v){
        if (includeTax) {
          total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
        } else {
          total += v.price.soldPrice * v.amount;
        }
      });
    }

    return total;
  };

  $scope.updateTotal = function() {
    $scope.totalExcludeTax = totalOrder();
    $scope.totalIncludeTax = totalOrder(true);
    $scope.totalTax        = totalOrder(true) - totalOrder();
  };

  $scope.updateTotal();  

  if($scope.order && $scope.order.customer && $scope.order.customer.priceList !== null){
    $scope.currentProject = $scope.order.customer.priceList;
  }else{
    if ($scope.publication.features.currentOrderProjectId) {
      var currentProject = $scope.projects.filter(function(project){
        return project.id === $scope.publication.features.currentOrderProjectId;
      });

      if (currentProject.length > 0) {
        $scope.currentProject = currentProject[0].price_list;
      }
    }
  }

  $scope.setDefautPricelist = function() {
    if ($scope.publication.features.currentOrderProjectId || ($scope.order.customer && $scope.order.customer.priceList !== null)) {
      angular.forEach($scope.order.items ,function(v){
        if (v.price.priceListId !== $scope.currentProject.id) {
          angular.forEach(v.product.pricelist, function(p){
            if ($scope.currentProject.id === p.priceListId) {
              v.price = angular.copy(p);
              v.price.soldPrice = v.price.price;
              CompanyPublicationCompanyOrderService.updateItem({
                companyId: $stateParams.companyId,
                publicationId: $stateParams.publicationId,
                orderId: $scope.order.id,
                itemId: v.id
              }, v);     
            }
          });
        }
      });
    }
    $scope.updateTotal();
  };

  $scope.updateNonProductsAdded = function(filter) {
    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
          return products.filter(function(item) {
            return !$scope.order.items.some(function(i) {
              return item.id === i.product.id;
            });
          });
        }).then(function(nonProducts) {
          if(nonProdcutAddedPromise === p) {
            $scope.nonProductsAdded = nonProducts;
          }
        });
        nonProdcutAddedPromise = p;
  };

  $scope.updateProducts = function(filter) {
    CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
      nonProdcutAddedPromise = products;
      $scope.nonProductsAdded = products;
    });
  };

  $scope.updateCompanyOrder = function(product) {
    var item = {
      product: product,
      amount: 1,
      price: {
        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
      }
    };
    return CompanyPublicationCompanyOrderService.updateItems({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      orderId: $scope.order.id
    }, item).$promise;
  };

  $scope.addProduct = function(product) {
    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
    angular.element('#filterProduct').val('');
    $scope.updateCompanyOrder(product).then(function(resp){
      resp = checkImageProduct(resp);
      var index = $scope.order.items.push(resp);
      $scope.order.items[index-1].price = angular.copy(product.pricelist[0]);
      $scope.order.items[index-1].price.soldPrice = $scope.order.items[index-1].price.price;
      $scope.setDefautPricelist();
      $scope.showModalEditItem($scope.order.items[index-1], index-1);
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  function checkImageProduct(item) {
    item.product.images = item.product.images.filter(function(item){
      return item.status === true;
    }); 
    if(item.product.images.length > 0){
      item.product.image = config.apiBase + "/files/" + item.product.images[0].id;
    }else{
      item.product.image = "images/no-image.jpg";
    }
    return item;
  }

  if ($scope.order) {
    angular.forEach($scope.order.items, function(item){
      checkImageProduct(item);
    });
  }

  $scope.update = function() {
    if($scope.order.customerOrderNr === ''){
      $scope.order.customerOrderNr = null;
    }
    $scope.order.$update({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, function(){
      growl.addSuccessMessage($translate.instant('order.update-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  $scope.createQuote = function() {
    $scope.order.$update({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      createQuote: true
    }, function(){
      CompanyPublicationCompanyOrderService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: $scope.order.id
      }).$promise.then(function(resp){
        $scope.order = resp;
      });
      growl.addSuccessMessage($translate.instant('order.update-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  $scope.removeProduct = function(index) {
    CompanyPublicationCompanyOrderService.deleteItem({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      orderId: $scope.order.id,
      itemId: $scope.order.items[index].id
    }, function(){
      $scope.order.items.splice(index, 1);
      $scope.updateTotal();
    });
  };

  $scope.showModalEditItem = function(item, index) {
    $modal({
      scope: $scope,
      controller: [
        'CompanyPublicationCompanyOrderService',
        '$stateParams',
        '$scope',
        '$timeout',
        'item',
        'index', function(
          CompanyPublicationCompanyOrderService,
          $stateParams,
          $scope,
          $timeout,
          item,
          index){
        $scope.item = item;

        $scope.save = function() {
          CompanyPublicationCompanyOrderService.updateItem({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            orderId: $scope.order.id,
            itemId: $scope.item.id
          }, $scope.item, function(resp){
            $scope.order.items[index] = resp;
            $timeout(function(){
              angular.element('.footable').trigger('footable_redraw');
            }, 0);
            $scope.$hide();
            $scope.updateTotal();
          });
        };
      }],
      templateUrl: 'partials/company-guest/company-order/detail/modal.html',
      show: true,
      resolve: {
        item: function() {
          return item || false;
        },
        index: function() {
          return (angular.isUndefined(index) ? -1 : index);
        }
      }
    });
  };

  $scope.nextStatus = function() {
    if ($scope.orderStatusesSorted.length === 0) {
      return;
    }
    if (!$scope.order.orderStatus) {
      $scope.order.orderStatus = $scope.orderStatusesSorted[0].id;
      $scope.update();
    } else {
      var index = $scope.orderStatusesSorted.findIndex(function(v){
        return v.id === $scope.order.orderStatus;
      });

      if (index >= ($scope.orderStatusesSorted.length - 1) || index < 0) {
        return;
      }
      $scope.order.orderStatus = $scope.orderStatusesSorted[index + 1].id;
      $scope.update();
    }
  };
  
  $scope.productPreview = function(product) {
    jQuery.fancybox.open([{
      type: 'image',
      padding: 0,
      margin: 0,
      href: product ? config.apiBase + '/files/' + product.id : ''
    }]);
    return false;
  };
}

CompanyGuestCompanyOrderDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: LIMIT + 1,
      offset: ($stateParams.page|0) * LIMIT,
      q: $stateParams.searchFile || "",
    }).$promise;
  }],
  order: ['$stateParams', 'CompanyPublicationCompanyOrderService', 'publication', function($stateParams, publicationCompanyOrderService, publication){
    if (publication.features.currentCompanyOrderId) {
      return publicationCompanyOrderService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: publication.features.currentCompanyOrderId,
        q: $stateParams.searchFile || ""
      }).$promise;
    }
  }],
  orderStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService){
    return CompanyService.queryOrderStatuses({
      companyId: $stateParams.companyId
    }).$promise;
  }],
  projects: ['CompanyProjectService', '$stateParams', function(CompanyProjectService, $stateParams){
    return CompanyProjectService.query({
      companyId: $stateParams.companyId,
      limit: 1000
    }).$promise;
  }]
};
module.exports = CompanyGuestCompanyOrderDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestCompanyOrderDetailCtrl', [
  '$scope',
  'publication',
  'order',
  'files',
  'translations',
  '$translate',
  '$stateParams',
  '$state',
  'orderStatuses',
  'CompanyPublicationService',
  'CompanyProductsService',
  'CompanyService',
  'CompanyCustomersService',
  'CompanyPublicationCompanyOrderService',
  '$sce',
  'config',
  '$filter',
  'activityService',
  '$modal',
  '$http',
  'projects',
  'growl',
  CompanyGuestCompanyOrderDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/company-order/CompanyGuestCompanyOrderDetailCtrl.js
// module id = 287
// module chunks = 0